import React, { useState, useEffect } from "react";
import { useHistory, Prompt } from "react-router-dom";
import ConfirmExitModal from "./confirmExitModal"; // مودالك المخصص

// الكومبوننت الرئيسي الذي يتعامل مع الحماية
function ExitPromptHandler({ children }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [nextLocation, setNextLocation] = useState(null);
  const [isBlocking, setIsBlocking] = useState(true);
  const history = useHistory();

  // حماية من التنقل الداخلي (عن طريق React Router)
  const handleBlockedNavigation = (location) => {
    if (!isBlocking) return true;
    setIsModalOpen(true);
    setNextLocation(location);
    return false;
  };

  // عند تأكيد المستخدم الخروج
  const handleConfirmNavigation = () => {
    setIsBlocking(false);
    setIsModalOpen(false);
    history.push(nextLocation.pathname); // تنفيذ التنقل
  };

  // عند إلغاء الخروج
  const handleCancelNavigation = () => {
    setIsModalOpen(false);
    setNextLocation(null);
  };

  // استخدام window.beforeunload لمنع التحديث أو الإغلاق
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isBlocking) {
        // إظهار نافذة التأكيد
        event.preventDefault();
        event.returnValue = ""; // بعض المتصفحات تحتاج هذه السطر لإظهار التحذير
      }
    };

    // إضافة الحدث قبل تحميل الصفحة
    window.addEventListener("beforeunload", handleBeforeUnload);

    // تنظيف الحدث عند إزالة الكومبوننت
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isBlocking]);

  return (
    <>
      {/* يتحكم بالتنقل داخل الموقع */}
      <Prompt when={isBlocking} message={handleBlockedNavigation} />

      {/* مودال التأكيد */}
      <ConfirmExitModal
        open={isModalOpen}
        onConfirm={handleConfirmNavigation}
        onCancel={handleCancelNavigation}
      />
    </>
  );
}

export default ExitPromptHandler;
